<template>
  <span class="d-inline-flex align-center flex-wrap" style="gap: 6px">
    <span v-if="order.remindedAt && !hideDate" class="text-caption text--secondary">
      {{ $t('onboarding.commissioning.reminder.last', { date: $options.filters.formatDate(order.remindedAt) }) }}
    </span>
    <!-- Grisé avec la raison plutôt que caché : on voit pourquoi on ne peut pas relancer. -->
    <v-tooltip bottom :disabled="!blockedBy">
      <template #activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <v-btn small outlined color="primary" :loading="working" :disabled="!!blockedBy" @click="remind">
            <v-icon left small>mdi-email-fast-outline</v-icon>{{ $t('onboarding.commissioning.reminder.send') }}
          </v-btn>
        </span>
      </template>
      <span>{{ blockedBy ? $t(`onboarding.commissioning.reminder.blocked.${blockedBy}`) : '' }}</span>
    </v-tooltip>
  </span>
</template>

<script>
import dayjs from 'dayjs'
import CommissioningRepository from '@repository/CommissioningRepository'

/**
 * Relancer la personne qui a encore sa part à faire : un e-mail qui lui redit quoi faire. Une fois par jour au plus
 * (le serveur en est juge) ; sans adresse e-mail, rien ne partirait. Rend la commande à jour (`updated`).
 */
export default {
  name: 'OrderReminderAction',

  props: {
    order: { type: Object, required: true },
    hideDate: { type: Boolean, default: false },
  },

  data() {
    return { working: false }
  },

  computed: {
    /** Pourquoi on ne peut pas relancer maintenant, ou null. Le jour se compte à l'heure de Paris, comme le serveur. */
    blockedBy() {
      if (!this.order.person?.email) return 'no-email'
      if (this.order.remindedAt && this.parisDay(this.order.remindedAt) === this.parisDay(new Date())) return 'today'
      return null
    },
  },

  methods: {
    parisDay(date) {
      return new Date(dayjs(date).valueOf()).toLocaleDateString('en-CA', { timeZone: 'Europe/Paris' })
    },

    async remind() {
      this.working = true
      try {
        const order = await CommissioningRepository.remind(this.order.id)
        this.notifySuccess('onboarding.commissioning.reminder.sent', { email: this.order.person?.email || '' })
        this.$emit('updated', order)
      } catch (e) {
        this.notifyError(e)
      } finally {
        this.working = false
      }
    },
  },
}
</script>
